
import React from 'react';

interface TextareaProps {
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
  required?: boolean;
  name?: string;
  id?: string;
  rows?: number;
  maxLength?: number;
  label?: string;
}

export const Textarea: React.FC<TextareaProps> = ({
  placeholder,
  value,
  onChange,
  className = '',
  required = false,
  name,
  id,
  rows = 4,
  maxLength,
  label,
}) => {
  const baseClasses = 'w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors resize-none';
  
  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor={id || name}>
          {label}
        </label>
      )}
      <textarea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`${baseClasses} ${className}`}
        required={required}
        name={name}
        id={id || name}
        rows={rows}
        maxLength={maxLength}
      />
    </div>
  );
};

export default Textarea;
